import './index.less'

import Borderx from './border/Borderx.vue'
import Drawerx from './drawer/Drawerx.vue'
import FormItemx from './form/FormItemx.vue'
import LocaleProviderx from './locale-provider/LocaleProviderx.vue'
import ConfirmTip from './modal/ConfirmTip.vue'
import Modalx from './modal/Modalx.vue'
import NumberPicker from './number-picker/NumberPicker.vue'
import Paginationx from './pagination/Paginationx.vue'
import PaginationxCheck from './paginationCheck/PaginationxCheck.vue'
import SearchButton from './search/SearchButton.vue'
import Searches from './search/Searches.vue'
import SearchGroup from './search/SearchGroup.vue'
import SearchItem from './search/SearchItem.vue'
import Tablex from './table/Tablex.vue'
import TablexCheck from './tableCheck/TablexCheck.vue'
import TableTree from './tableTree/TableTree.vue'
import Treex from './tree/Treex.vue'
import TreexV2 from './treexV2/TreexV2.vue'

import modalx from './modal/modalx'
import selectx from './select/selectx'
import tablex from './table/tablex'
import tablexCheck from './tableCheck/tablexCheck'
import tool from '../tool/tool'

import conf from '../../../conf'

export default {
  init (Vue, router, i18n) {
    Vue.component(Borderx.name, Borderx)
    Vue.component(Drawerx.name, Drawerx)
    Vue.component(FormItemx.name, FormItemx)
    Vue.component(LocaleProviderx.name, LocaleProviderx)
    Vue.component(ConfirmTip.name, ConfirmTip)
    Vue.component(Modalx.name, Modalx)
    Vue.component(NumberPicker.name, NumberPicker)
    Vue.component(Paginationx.name, Paginationx)
    Vue.component(PaginationxCheck.name, PaginationxCheck)
    Vue.component(SearchButton.name, SearchButton)
    Vue.component(Searches.name, Searches)
    Vue.component(SearchGroup.name, SearchGroup)
    Vue.component(SearchItem.name, SearchItem)
    Vue.component(Tablex.name, Tablex)
    Vue.component(TablexCheck.name, TablexCheck)
    Vue.component(Treex.name, Treex)
    Vue.component(TableTree.name, TableTree)
    Vue.component(TreexV2.name, TreexV2)

    const toolInstance = tool.newInstance(router, i18n)

    Vue.prototype.$antdx = {
      tool: toolInstance,
      modal: modalx.newInstance(toolInstance),
      select: selectx.newInstance(toolInstance),
      table: tablex.newInstance(toolInstance),
      tablexCheck: tablexCheck.newInstance(toolInstance)
    }

    Vue.prototype.$notification.config({
      duration: conf.notificationKeep
    })

    Vue.prototype.$message.config({
      duration: conf.messageKeep,
      maxCount: 1
    })
  }
}
